export const JURISDICTIONS = [
  "United States — Delaware",
  "United States — Wyoming",
  "United Kingdom",
  "Singapore",
  "Hong Kong",
  "UAE — Dubai",
  "British Virgin Islands",
  "Cayman Islands",
  "Estonia",
];

export const ENTITY_TYPES = [
  "LLC",
  "C-Corporation",
  "Private Limited (Ltd)",
  "Limited Liability Partnership",
  "Free Zone Company",
  "Offshore IBC",
];

export const STAGES = [
  "Submitted",
  "Payment Confirmed",
  "Document Review",
  "Government Filing",
  "Delivered",
];

export const CATEGORY_ORDER = ["Incorporation", "Banking", "Compliance"];

export const CONTACT = {
  phone: "+852 9854 8459",
  phoneHref: "tel:+85298548459",
  email: "info@uniincorp.com",
  address: "Suite C, Level 7, World Trust Tower, 50 Stanley Street, Hong Kong",
  whatsapp: "https://wa.me/85298548459",
};

// Single source of truth for legal/business identity (fallback defaults).
// Live values are overridden by Admin → Settings via site config (company_*).
// Empty legal fields render as "Requires Confirmation".
export const REQUIRES_CONFIRMATION = "Requires Confirmation";
export const IDENTITY = {
  legal_name: "UNICORP Services Limited",
  display_name: "UNICORP",
  reg_number: "",
  jurisdiction: "",
  office: "Suite C, Level 7, World Trust Tower, 50 Stanley Street, Hong Kong",
  email: "info@uniincorp.com",
  phone: "+852 9854 8459",
  website: "https://uniincorp.com",
};

export const SERVICE_INTERESTS = [
  "Company Incorporation",
  "Corporate Bank Account",
  "Accounting, Tax & Compliance",
  "Licensing & Regulatory",
  "Trusts, Foundations & Funds",
  "EIN / ITIN & US Services",
  "Partnership Enquiry",
  "Other",
];

export function formatUSD(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);
}
